import React, { useEffect } from "react";
import { conf } from "./const";
import { fetchData } from "./js/main";

export default function Logout() {
  useEffect(() => {
    (async () => {
      const cookie = JSON.parse(localStorage.getItem(conf.cookieName));
      if (cookie && cookie.access_token) {
        await fetchData("delete", "/signout");
      }
      localStorage.removeItem(conf.cookieName);
      const url = conf.endpoint.auth + "/signout/" + cookie.access_token;
      window.location = url;
    })();
  }, []);

  return <div></div>;
}
